namespace $.$$ {

	$mol_style_define( $shm_hitalama_map_pane_tool, {

		position: 'absolute',
		top: 0,
		right: 0,
		bottom: 0,
		left: 0,
		zIndex: 1,
		transition: 'none',

		Svg: {
			width: '100%',
			height: '100%',
			overflow: 'visible',
			pointerEvents: 'none',
			transition: 'none',
		},

		Stroke: {
			pointerEvents: 'none',
			transition: 'none',
		},
		Rect: {
			pointerEvents: 'none',
			transition: 'none',
		},
		Circle: {
			pointerEvents: 'none',
			transition: 'none',
		},

	} )

}
